import {
  TrackerAddMealConnectorApollo,
  TrackerMealConnectorApollo,
  AddUserMealToTrackerConnectorApollo,
  SaveAsUserMealConnectorApollo,
  useAppContext,
} from '@front-activerse/common-components';
import { useParams } from 'react-router-dom';
import TrackerAddMealContainer from './TrackerAddUserMealContainer';

const TrackerIndexPage = () => {
  const { dietMealId } = useParams();
  const { post } = useAppContext();

  if (!dietMealId) {
    return <div>Missing parameters</div>;
  }

  return (
    <TrackerMealConnectorApollo mealId={+dietMealId}>
      {(trackerMealData: any) => (
        <TrackerAddMealConnectorApollo post={post}>
          {({ addMeal }: { addMeal: (input: any, saveYourMeal: boolean) => Promise<any> }) => (
            <AddUserMealToTrackerConnectorApollo post={post}>
              {({ addUserMeal }: { addUserMeal: (input: any) => Promise<any> }) => (
                <SaveAsUserMealConnectorApollo post={post}>
                  {({ saveAsUserMeal }: { saveAsUserMeal: (input: any) => Promise<any> }) => (
                    <TrackerAddMealContainer
                      {...trackerMealData}
                      loading={trackerMealData.loading}
                      addMeal={addMeal}
                      addUserMeal={addUserMeal}
                      saveAsUserMeal={saveAsUserMeal}
                      dietMealId={dietMealId}
                      key={dietMealId}
                    />
                  )}
                </SaveAsUserMealConnectorApollo>
              )}
            </AddUserMealToTrackerConnectorApollo>
          )}
        </TrackerAddMealConnectorApollo>
      )}
    </TrackerMealConnectorApollo>
  );
};

export default TrackerIndexPage;
